import { WorkspaceActionsProps } from './WorkspaceActions';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../service/store/Store.constants';
import useDeviceStatusFromWorkspace from '../../../../../service/device/CommanderAPI/hooks/useDeviceStatusFromWorkspace';
import { CloudOnIcon } from '../../../../../assets';

export function WorkspaceCommanderStatusAction(props: WorkspaceActionsProps) {
  const { workspace, active } = props;
  const {
    numberFailingMqttConnection,
    isLoading: isLoadingDeviceStatus,
    commanderIdsDevices,
  } = useDeviceStatusFromWorkspace(workspace?.id ?? '', {
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const loading = isLoadingDeviceStatus;
  if (!loading && !commanderIdsDevices?.length) return null;

  const numberStoresOK =
    (commanderIdsDevices?.length ?? 0) - (numberFailingMqttConnection ?? 0);

  const storesOk = numberStoresOK ? (
    <Box
      sx={{
        fontSize: '1rem',
        width: '6rem',
        height: '3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack direction={'row'} spacing={0.5}>
        <Typography
          component="span"
          variant={'inherit'}
          color={!active ? 'success' : 'inherit'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CloudOnIcon height={'1.5em'} />
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          fontSize={'1rem'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          |
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          display={'flex'}
          alignItems={'center'}
          fontSize={'1rem'}
          justifyContent={'center'}
          color={'text.primary'}
        >
          {numberStoresOK}
        </Typography>
      </Stack>
    </Box>
  ) : null;

  return storesOk;
}

export default memo(WorkspaceCommanderStatusAction);
